/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constant';

export const getList = (buildingId, payload, callback) =>
  req.list(
    c.GET_ADDITIONAL_ITEMS_LIST,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_additional_items?isPaginate=1`,
    payload,
    callback
  );

export const showData = (buildingId, id, payload, callback) =>
  req.item(
    c.SHOW_ADDITIONAL_ITEMS_DATA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_additional_items/${id}`,
    payload,
    callback
  );

export const createData = (buildingId, payload, callback) =>
  req.create(
    c.CREATE_ADDITIONAL_ITEMS_DATA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_additional_items`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateData = (id, payload, callback) =>
  req.update(
    c.UPDATE_ADDITIONAL_ITEMS_DATA,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}/building_additional_items `,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getActualUseList = (payload, callback) =>
  req.list(
    c.GET_ACTUAL_USE_LIST,
    'api/v1/rpt/administrator/settings/actual_uses?status=1',
    payload,
    callback
  );

export const getFloorArea = (buildingId, payload, callback) =>
  req.list(
    c.GET_FLOOR_AREA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_floor_storey_areas`,
    payload,
    callback
  );

export const getBuildingComponents = (payload, callback) =>
  req.list(
    c.GET_BUILDING_COMPONENTS,
    'api/v1/rpt/administrator/buildings/settings/building_components',
    payload,
    callback
  );

export const getSingleBuildingComponent = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_BUILDING_COMPONENT,
    `api/v1/rpt/administrator/buildings/settings/building_components/${id}`,
    payload,
    callback
  );

export const getSingleBuildingApplication = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_BUILDING_APPLICATION,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}`,
    payload,
    callback
  );